import { render, staticRenderFns } from "./SaludoCliente.vue?vue&type=template&id=568eb52c&scoped=true&"
import script from "./SaludoCliente.vue?vue&type=script&lang=js&"
export * from "./SaludoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568eb52c",
  null
  
)

export default component.exports